import { useState } from "react";

const DISMISSED_KEY = "incassaflow_ios_install_dismissed";

function isIos(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !("MSStream" in window);
}

function isInStandaloneMode(): boolean {
  return "standalone" in window.navigator && (window.navigator as unknown as { standalone: boolean }).standalone;
}

export function IosInstallHint() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === "true"
  );

  if (!isIos() || isInStandaloneMode() || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(DISMISSED_KEY, "true");
  };

  return (
    <div className="ios-install-hint">
      <span className="ios-install-hint-icon" aria-hidden="true">📲</span>
      <span>
        Per installare IncassaFlow, tocca{" "}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline", verticalAlign: "middle" }}>
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
          <polyline points="16 6 12 2 8 6" />
          <line x1="12" y1="2" x2="12" y2="15" />
        </svg>{" "}
        e poi <strong>Aggiungi a Home</strong>.
      </span>
      <button onClick={handleDismiss} aria-label="Chiudi">&times;</button>
    </div>
  );
}
